import cn from 'classnames';
import { MdDeleteForever } from 'react-icons/md';
import { OrderIcon } from '../../../../../../../../assets/svg/order';
import { Collapse } from '../../../../../../../../components/collapse/collapse';
import { Container } from '../../../../../../../../components/container/container';
import { IconButton } from '../../../../../../../../components/icon-button/icon-button';
import { Modal, ModalProps } from '../../../../../../../../components/modal/modal';
import { Select } from '../../../../../../../../components/select/select';
import { DeleteModal } from '../../../../../../../../features/delete-modal/delete-modal';
import { EditableLabel } from '../../../../../../../../features/editable-label/editable-label';
import { HasAccess, HasAccessProps } from '../../../../../../../../features/has-access/has-access';
import { SortableItem } from '../../../../../../../../features/sorter/sortable-item';
import { Sorter } from '../../../../../../../../features/sorter/sorter';
import { useManagerStore } from '../../../../../../../../store/use-manager-store';
import { MenuInformerCreateUnit } from '../menu-informer-create-unit';
import s from './menu-informer-create-category-modal.module.css';
import { useMenuInformerCreateCategoryModal } from './use-menu-informer-create-category-modal';

export const MenuInformerCreateCategoryModal = (props: ModalProps) => {
  const {
    handleUpdate,
    t,
    section = { id: '', value: '' },
    getLocale,
    categories,
    handleCreate,
    isLoading,
    setCategoryListOrder,
    setDishListOrder,
    deleteCategory,
    addQueryParams,
    setSection,
    language,
    sections,
  } = useMenuInformerCreateCategoryModal();

  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('menu', ['write']);
  const hasAccessProps: HasAccessProps = { service: 'menu', permissions: ['write'] };

  return (
    <Modal
      className={cn(props.className, s.feature)}
      title={t('Категории раздела') + ' ' + section.value}
      withLang
      {...props}
    >
      <Container label={t('Раздел')}>
        <Select
          value={section}
          options={sections}
          onSelect={setSection}
          data-testid="section-input"
        />
      </Container>

      <HasAccess {...hasAccessProps}>
        {!!section?.id && (
          <MenuInformerCreateUnit
            placeholder={t('Добавить категорию')}
            isLoading={isLoading}
            name="createCategoryName"
            onConfirm={handleCreate}
            data-testid="create-unit"
          />
        )}
      </HasAccess>
      {!!categories.length && !!section?.id && (
        <>
          <Sorter
            itemIds={categories.map((item) => item.id)}
            onSort={(e) => setCategoryListOrder(e.map(Number), Number(section.id))}
            axis="y"
            isDisabled={isNotAllowed}
          >
            <ul className={s.categories}>
              {categories.map((item, index) => (
                <SortableItem
                  key={item.id}
                  sortableArgs={{
                    id: item.id,
                    data: {
                      index,
                    },
                  }}
                  withSortIcon={false}
                >
                  <Collapse
                    id={`category-${index}`}
                    key={item.id}
                    motionKey={item.id}
                    headerClassName={s.headerWrapper}
                    header={
                      <div className={s.header}>
                        <HasAccess {...hasAccessProps}>
                          <IconButton variant="ghost">
                            <OrderIcon />
                          </IconButton>
                        </HasAccess>

                        <EditableLabel
                          value={getLocale(item.name, language)}
                          onConfirm={(e) =>
                            handleUpdate({ ...item, name: { ...item.name, [language]: e } })
                          }
                          name="editCategoryName"
                          data-testid={`category-name-${index}`}
                          isDisabled={isNotAllowed}
                        />

                        <HasAccess {...hasAccessProps}>
                          <div className={s.actions}>
                            <IconButton
                              data-testid={`category-delete-${index}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                addQueryParams({
                                  deleteId: item.id.toString(),
                                  deleteName: getLocale(item.name, language),
                                });
                              }}
                              size="sm"
                              variant="secondary"
                            >
                              <MdDeleteForever />
                            </IconButton>
                          </div>
                        </HasAccess>
                      </div>
                    }
                    children={
                      <Sorter
                        itemIds={item.dishes?.map((item) => item.id) || []}
                        isDisabled={isNotAllowed}
                        onSort={(e) =>
                          setDishListOrder({
                            order: e.map(String),
                            section_id: Number(section.id),
                            category_id: item.id,
                          })
                        }
                        axis="y"
                      >
                        <ul className={s.dishes}>
                          {item.dishes?.map(({ id, name }, index) => (
                            <SortableItem
                              key={id}
                              className={s.dish}
                              isDisabled={isNotAllowed}
                              sortableArgs={{
                                id,
                                data: {
                                  index,
                                },
                              }}
                            >
                              {getLocale(name, language)}
                            </SortableItem>
                          ))}
                        </ul>
                      </Sorter>
                    }
                  />
                </SortableItem>
              ))}
            </ul>
          </Sorter>
        </>
      )}
      <DeleteModal onSubmit={deleteCategory} />
    </Modal>
  );
};
